import { useEffect, useState } from "react";
import { SudoButton } from "src/sudokit/components/SudoButton";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip/index.tsx";
import { cn } from "../../../lib/cn";
import { useStickyTourStore } from "src/stores/stickyTourStore";
import { TourSignal } from "src/components/StickyTour/TourTypes";

const GenerateButton = ({
  //
  generate,
  generateDisabled,
  generateDisabledMessage,
  requesting,
  outOfQuota,
  type,
  setRequested,
  setLastInvocation,
  abortStream,
  setIsGenerating,
  requestRewrite,
  value,
  isStreaming,
}) => {
  const [localRequested, setLocalRequested] = useState(false);
  const sendFlowSignal = useStickyTourStore((state) => state.sendFlowSignal);
  const handleClick = () => {
    // If streaming and we initiated it, cancel
    if (localRequested && isStreaming && abortStream) {
      abortStream();
      setLocalRequested(false);
      return;
    }

    // If there's a value and we haven't requested yet, it's a rewrite
    if (value && !localRequested && requestRewrite) {
      sendFlowSignal(TourSignal.STORY_BIBLE_SYNOPSIS_REWRITE_CLICKED);
      requestRewrite();
      return;
    }

    // Otherwise, it's a generate
    setLocalRequested(true);
    setIsGenerating && setIsGenerating(true);
    sendFlowSignal(TourSignal.STORY_BIBLE_SYNOPSIS_GENERATE_CLICKED);
    if (generate()) {
      setRequested && setRequested(true);
      setLastInvocation && setLastInvocation(null);
    }
  };

  const tooltipContent = generateDisabled ? <div className="text-sm">{generateDisabledMessage}</div> : null;

  // Determine button state and label
  const isGenerating = localRequested && requesting && !isStreaming;
  const isCancel = localRequested && isStreaming;
  const isRewrite = Boolean(value) && !localRequested;

  let buttonLabel = "Generate";
  let leftIcon = "/assets/AI-sparkle.svg";

  if (isGenerating) {
    buttonLabel = "Generating";
  } else if (isCancel) {
    buttonLabel = "Cancel";
  } else if (isRewrite) {
    buttonLabel = "Rewrite";
    leftIcon = "/assets/rewrite-icon.svg";
  }

  const practicallyDisabled = isGenerating || (!localRequested && (requesting || outOfQuota || generateDisabled));

  useEffect(() => {
    // Reset localRequested when generation completes
    if (localRequested && !requesting && !isStreaming) {
      setLocalRequested(false);
    }
  }, [requesting, isStreaming, localRequested]);
  return (
    <div
      className="mt-0"
      id={`button-container-generate-${type}`}
    >
      <SudoTooltip
        content={tooltipContent}
        disabled={!generateDisabled}
        tooltipClassName="w-[32rem] max-w-[90vw] p-4"
        hasArrow={false}
      >
        <SudoButton
          // id could be button-rewrite-synopsis, button-generate-synopsis etc
          id={`button-${isRewrite ? "rewrite" : "generate"}-${type}`}
          variant="tertiary"
          className={cn("fill-app mt-0 mb-2 primary-cta-high-contrast rounded generate-button-custom")}
          leftIcon={leftIcon}
          onClick={handleClick}
          disabled={practicallyDisabled}
          {...(isGenerating ||
            (isCancel && {
              state: "loading",
              loadingPercentage: 90,
              loadingTransitionDuration: 5,
            }))}
        >
          {buttonLabel}
        </SudoButton>
      </SudoTooltip>
    </div>
  );
};

export default GenerateButton;
